<template>
  <div>
    <section>

      <div class="text-start pt-4 ps-4">
        <img
          src="../../../assets/logoLogin/logoGrupoWhite.png"
          class="py-1"
          width="155"
          height="60"
          alt=""
        />
      </div>

    
      <div class="form-box d-flex flex-column justify-content-center align-items-center">

        <div class="card card-login text-white">

          <div class="text-center mb-3">
            <img
              src="../../../assets/logoLogin/topas.png"
              class="py-1"
              width="120"
              height="120"
              alt=""
            />
          </div>

          
          <form @submit.prevent="login(user)"> 
            <div class="d-flex mt-4 input-container">
              <i class="bi bi-person fs-5 text-secondary"></i>
              <input
                type="text"
                placeholder="Usuario o correo"
                required
                v-model="user.usuCodigo"
              />
            </div>

            
            <div class="d-flex mt-4 input-container position-relative">
              <i class="bi bi-key fs-5 text-secondary"></i>
              <input
                :type="mostrarPassword ? 'text' : 'password'"
                placeholder="Contraseña"
                required
                v-model="user.usuContrasena"
              />
              <i
                class="bi fs-5 text-secondary"
                :class="mostrarPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'"
                @click="mostrarPassword = !mostrarPassword"
                style="cursor: pointer; position: absolute; right: 10px;"
              ></i>
            </div>

           
            <div class="mt-4">
              <button class="btn btn-success w-100 py-2">
                Ingresar
              </button>
            </div>

            
            <div class="text-center mt-3">
              <a class="pointer text-white" @click="MandarOlvido">
                ¿Deseas cambiar la contraseña?
              </a>
            </div>

           
           

          </form>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SolimanoextranetHomeView",

  data() {
    return {
      error: false,
      error_msg: "el usuario o contraseña es incorrecto",
      aumentar: false,
      spinner: false,
      boton: true,
      user: {
        usuCodigo: "",
        usuContrasena: "",
      },
      mostrarPassword: false,
    };
  },

  methods: {
    ...mapActions("auth", ["login"]),

    MandarOlvido() {
      this.$router.push("/validation");
    },
  },

  computed: {
    ...mapGetters("auth", ["Users"]),
    ...mapGetters("auth", ["Tokens"]),
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}


section {
  position: relative;
  min-height: 100dvh;
  width: 100vw;
  background-image: url("../../../assets/logoLogin/grande.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  overflow: hidden;
}


section::before {
  content: "";
  position: absolute;
  inset: 0;
  background-color: rgba(0, 44, 93, 0.93);
  z-index: 1;
}

section > * {
  position: relative;
  z-index: 2;
}

/* Contenedor principal */
.form-box {
  width: 100%;
  padding: 4.5rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* CARD */
.card-login {
  width: 100%;
  max-width: 380px;
  padding: 1.2rem 1.4rem;
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.6);
  border-radius: 14px;
  backdrop-filter: blur(6px);
}

/* Logo central */
.card-login img {
  width: 95px;
  height: 95px;
}


.input-container {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(255, 255, 255, 0.95);
  padding: 0.25rem 0.45rem;
  border-radius: 6px;
}


input {
  flex: 1;
  line-height: 28px;
  padding: 2px 6px;
  border: none;
  font-size: 0.9rem;
  outline: none;
  background-color: transparent;
}


button.btn {
  padding: 0.45rem;
  font-size: 0.9rem;
}


.pointer {
  cursor: pointer;
  font-size: 0.75rem;
}


@media (max-width: 570px) {
  .card-login {
    padding: 1.1rem 1.2rem;
  }

  .card-login img {
    width: 85px;
    height: 85px;
  }
}

</style>

 